import AutomaticPlannerScreenContainer from './AutomaticPlannerScreenContainer';

export default AutomaticPlannerScreenContainer;
